import React from 'react';
import about from '../../../images/about.jpg'

const About = () => {
    return (
        <div id="about">
            <div className="container m-5 mx-auto">
                <div className="d-flex flex-column flex-lg-row justify-content-center align-items-center shadow-lg w-75 mx-auto">
                    <div className="col-lg-6 col-12">
                        <img src={about} className="img-fluid p-3 p-lg-5" alt="" />
                    </div>
                    <div className="col-lg-6 col-12 text-start px-4">
                        <h3 className="fw-bold text-color">About Me</h3>
                        <p style={{ fontFamily: "open sans", fontSize: "14px", lineHeight: "1.5rem" }}>Hey!!
                            I am Imam Hassan Rimon from Bangladesh. I always like to creating something new to with my webpixi world. My new ideas show me, how to be professional and to much originative. Proper activity in a work is important. That's why I always try to give more attention to my work.</p>

                        <br />
                        <a style={{ textDecoration: 'none' }} target="_blank" rel="noreferrer" href="https://drive.google.com/uc?export=download&id=1PhU3bSSfaPaHWbAGVLDPvel-C0SGFyIe"><button className="btn btn-bg text-light px-3 mb-3 rounded-pill">Download Resume</button></a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;